var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPlusCircleFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C13.9707 4.23267e-08 18 4.02929 18 9C18 13.9707 13.9707 18 9 18C4.02929 18 4.23281e-08 13.9707 0 9C0 4.02929 4.02929 0 9 0ZM9.16895 5C8.81445 5.00024 8.52854 5.28612 8.52832 5.64062V8.52832H5.64062C5.28612 8.52854 5.00024 8.81445 5 9.16895C5 9.52365 5.28597 9.81033 5.64062 9.81055H8.52832V12.6973C8.52832 13.052 8.81431 13.3386 9.16895 13.3389C9.52379 13.3389 9.81055 13.0521 9.81055 12.6973V9.81055H12.6973C13.0521 9.81055 13.3389 9.52379 13.3389 9.16895C13.3386 8.81431 13.052 8.52832 12.6973 8.52832H9.81055V5.64062C9.81033 5.28597 9.52365 5 9.16895 5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlusCircleFill);
export default __webpack_public_path__ + "static/media/icon-plus-circle-fill.e38a34ba172d5c333d833c1607a0d69a.svg";
export { ForwardRef as ReactComponent };